import { Grid } from '@mui/material';
import { useCallback, useState } from 'react';
import { deleteVehicle, getAllVehicles } from '../../../../api/transports';
import useFetchList from '../../../../hooks/useFetchList';
import { useSelector } from '../../../../redux/store';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import { vehicleColumns } from '../../../../reusable-components/datagrid/vehicleColumns';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import VehicleModal from './VehicleModal';

export default function Vehicles() {
  const { enqueueSnackbar } = useSnackbar();
  const [refreshKey, setRefreshKey] = useState(1);
  const [vehicles, vehiclesLoading, vehiclesError] = useFetchList(getAllVehicles, [refreshKey], []);
  const transportsState = useSelector((state) => state.transports);
  const facilities = transportsState?.data?.facilities ?? [];
  const facilityDataIsLoading = transportsState?.isLoading ?? false;
  // Preprocess vehicles to add facilityName
  const processedVehicles = vehicles.map((vehicle) => {
    const facility = facilities.find((f) => f.value === vehicle.facilityId);
    return {
      ...vehicle,
      facilityName: facility ? facility.label : '',
    };
  });

  const customToolbar = useCallback(
    () => (
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end">
        <VehicleModal onAdded={() => setRefreshKey((k) => k + 1)} />
      </Grid>
    ),
    []
  );

  const handleDelete = async (vehicleId) => {
    try {
      const response = await deleteVehicle(vehicleId);
      const result = response.data;
      if (result.success) {
        enqueueSnackbar('Vehicle deleted successfully', { variant: 'success' });
        setRefreshKey((k) => k + 1);
      } else {
        enqueueSnackbar(result.message || 'Failed to delete Vehicle', { variant: 'error' });
      }
    } catch (error) {
      const errorMsg = 'Failed to delete Vehicle';
      enqueueSnackbar(errorMsg, { variant: 'error' });
    }
  };

  const ActionButtons = (params) => (
    <>
      <VehicleModal edit row={params.row} onAdded={() => setRefreshKey((k) => k + 1)} />

      {/* <ConfirmDialog
        icon="delete-outline"
        title="Delete"
        color="error"
        content={`Are you sure you want to delete this vehicle?`}
        actionButton="Delete"
        action={() => handleDelete(params.row.id)}
        tooltip={`Delete`}
      /> */}
    </>
  );

  const actions = {
    field: 'actions',
    headerName: 'Actions',
    disableReorder: true,
    width: 180,
    renderCell: (params) => ActionButtons(params),
    id: 'actions',
    className: 'actions',
  };

  return (
    <>
      <Grid item xs={12}>
        <CustomDataGrid
          gridId="transports-vehicles"
          boxSX={{ height: 'calc(100vh - 225px)' }}
          data={processedVehicles}
          gridColumns={[...vehicleColumns, actions]}
          CustomLeftToolbar={customToolbar}
          getRowId={(row) => `${row.id}`}
          isLoading={facilityDataIsLoading || vehiclesLoading}
        />
      </Grid>
    </>
  );
}
